module.exports = __webpack_public_path__ + "static/1-b74ed1f1466c0d51b2b6da56bab24950.jpg";